module.exports = {"term_agreement_by_ll_owner":"Условия соглашения со стороны арендодателя/владельца объекта недвижимости"};